import React, { memo } from 'react'
import { ClientSecureWrapper } from 'src/components/layout/client/ClientSecureWrapper'
import { InsuranceBeneficiaryForm } from 'src/components/client/insurance-beneficiary-form/InsuranceBeneficiaryForm'

const InsuranceBeneficiaryPageComponent = () => {
  return (
    <ClientSecureWrapper>
      <InsuranceBeneficiaryForm />
    </ClientSecureWrapper>
  )
}

export const InsuranceBeneficiaryPage = memo(InsuranceBeneficiaryPageComponent)
